import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { Tracking } from '@/features/tracking'

const trackingSearchSchema = z
  .object({
    branch: z.string().optional(),
    startDate: z.string().optional(),
    language: z.string().optional(),
  })
  .catch({})

export const Route = createFileRoute('/_authenticated/tracking/')({
  validateSearch: trackingSearchSchema,
  beforeLoad: ({ search }) => {
    if (!search?.language) {
      throw redirect({
        to: '/tracking',
        search: {
          branch: search?.branch,
          startDate: search?.startDate,
          language: 'en',
        },
      })
    }
  },
  component: Tracking,
})
